import React, { useState } from "react";
import { BiCopy } from "react-icons/bi";
import {
  AiFillCheckCircle,
  AiOutlineDownload,
  AiOutlineMail,
} from "react-icons/ai";
import { FiExternalLink } from "react-icons/fi";

function ClipboardCopy({ copyText }) {
  const [isCopied, setIsCopied] = useState(false);

  // This is the function we wrote earlier
  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand("copy", true, text);
    }
  }

  // onClick handler function for the copy button
  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(copyText)
      .then(() => {
        // If successful, update the isCopied state value
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const openNewTab = () => {
    window.open(copyText, "_blank"); //to open new page
  };

  return (
    <div className="align-middle flex justify-center items-center">
      <input
        type="text"
        className="rounded bg-slate-50 border-2 border-slate-200 text-ellipsis text-s"
        value={copyText}
        readOnly
      />
      {/* Bind our handler function to the onClick button property */}
      <button
        className="ml-2 rounded bg-slate-50 border-2 border-slate-200 text-center pl-2 pr-2"
        onClick={handleCopyClick}
      >
        <span>{isCopied ? <AiFillCheckCircle /> : <BiCopy />}</span>
      </button>

      <button
        className="ml-2 rounded bg-slate-50 border-2 border-slate-200 text-center pl-2 pr-2"
        onClick={openNewTab}
      >
        <span>
          <FiExternalLink />{" "}
        </span>
      </button>
    </div>
  );
}

function MintedStatus() {
  return (
    <div className="align-middle flex justify-center items-center">
      <AiFillCheckCircle />
      <span className="text-xs text-gray-700 mr-3 ml-1 mb-2 mt-2">
        Minted (NFT claimed)
      </span>
    </div>
  );
}

function EmailedStatus() {
  return (
    <div className="align-middle flex justify-center items-center">
      <AiOutlineMail />
      <span className="text-xs text-gray-700 mr-3 ml-1 mb-2 mt-2">
        Emailed (NFT unclaimed)
      </span>
    </div>
  );
}

class ShareSheet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="mt-4">
        <div className="px-6 mb-3 pt-4 pb-2 bg-purple-100 rounded max-w-sm min-w-sm">
          <div className="font-bold text-xl mb-2">Share this award</div>

          {this.props.directMint ? <MintedStatus /> : <EmailedStatus />}

          <div className="font-bold text-m mb-2 mt-5">Ribbon permalink:</div>
          <ClipboardCopy
            copyText={`${process.env.REACT_APP_RIBBON_PLATFORM_URL}/award/${this.props.awardId}`}
          />

          {this.props.directMint ? (
            <div>
              <div className="font-bold text-m mb-2 mt-5">
                View on polygonscan:
              </div>
              <ClipboardCopy copyText={this.props.polygonscanUrl} />
            </div>
          ) : null}

          {this.props.directMint ? (
            <div>
              <div className="font-bold text-m mb-2 mt-5">View on OpenSea:</div>
              <ClipboardCopy copyText={this.props.openseaUrl} />
            </div>
          ) : null}
        </div>

        {/* <div className="px-6 pt-4 pb-2 mt-4 bg-purple-100 rounded max-w-sm">
          <div className="align-middle flex justify-center items-center text-bluer font-bold text-xl mb-2">
            <a href="https://ribbon.cool">Sign up to Ribbon now</a>
          </div>
        </div> */}
      </div>
    );
  }
}

export default ShareSheet;
